/* unplugin-vue-components disabled */import { render } from "./ReferenceTable2.vue?vue&type=template&id=56e66743&scoped=true&ts=true"
import script from "./ReferenceTable2.vue?vue&type=script&lang=ts"
export * from "./ReferenceTable2.vue?vue&type=script&lang=ts"

import "./ReferenceTable2.vue?vue&type=style&index=0&id=56e66743&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e66743"]])

export default __exports__